export default __webpack_public_path__ + "static/media/toan.4ac293dd.jpg";